import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface AddUsersToDataAlertsParams {
  dataAlertIds: string[];
  userIds: string[];
}

export class AddUsersToDataAlertsRequest extends Request<AddUsersToDataAlertsParams, IResult> {
  constructor(params: AddUsersToDataAlertsParams) {
    super('addUsersToDataAlerts', params);
  }
}
